import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Product Category
      {record ? `: ${record.category_name}` : ''}
    </span>
  );
};
